import { render } from "./JsonPreview.vue?vue&type=template&id=eb128632"
import script from "./JsonPreview.vue?vue&type=script&lang=js"
export * from "./JsonPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__